import React from 'react';

const Content = ({children, menusIsOpen}) => {
    return (
        <div className={`p-3 ${!menusIsOpen ? "sm:ml-64 h-[calc(100vh-42.6px)] lg:h-[calc(100vh-42.6px)]" : ""} mt-9`}>
            <div className="flex-grow p-2 bg-gray-100">
                {children}
            </div>
        </div>
    );
};

export default Content;